"use client";

import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * زرّ إغلاق النوافذ والأقسام المنبثقة: أيقونة × وحدها (طلب المالك 2026-10-08 — كانت
 * كلمة «إغلاق» نصًّا في زوايا النوافذ). الشكل نفسه الذي في `dialog.tsx` (ghost · 8×8)
 * فتتّبع ألوان الثيم، والاسم للقارئ الآليّ والتلميح.
 */
export function CloseButton({
  onClick,
  label = "إغلاق",
  className,
  disabled,
}: {
  onClick: () => void;
  label?: string;
  className?: string;
  disabled?: boolean;
}) {
  return (
    <Button
      type="button"
      size="icon"
      variant="ghost"
      aria-label={label}
      title={label}
      onClick={onClick}
      disabled={disabled}
      className={["h-8 w-8 shrink-0", className].filter(Boolean).join(" ")}
    >
      <X className="w-4 h-4" aria-hidden="true" />
    </Button>
  );
}
